import { apiClient } from "./client"

export async function fetchPoptavky({ stav = "" } = {}) {
  const qs = new URLSearchParams()
  if (stav !== "" && stav !== null && stav !== undefined) qs.set("stav", String(stav))
  return apiClient.get(`/poptavky?${qs.toString()}`)
}

export async function createPoptavka(payload) {
  return apiClient.post("/poptavky", payload)
}

export async function updatePoptavka(id, payload) {
  return apiClient.put(`/poptavky/${id}`, payload)
}

export async function deletePoptavka(id) {
  return apiClient.del(`/poptavky/${id}`)
}

export async function fetchPoptavkySuggestions({ field = "", q = "", limit = 10 } = {}) {
  const qs = new URLSearchParams()
  if (field) qs.set("field", String(field))
  if (q) qs.set("q", String(q))
  if (limit !== "" && limit !== null && limit !== undefined) qs.set("limit", String(limit))
  return apiClient.get(`/poptavky/suggest?${qs.toString()}`)
}
